import Link from 'next/link';
import { FC, JSX } from 'react';
import Project from '~/data/strapi/types/collection-types/project';
import AppRoute from '~/enums/app-route';

import styles from './styles.module.css';

interface Props {
  project: Project;
  variant?: 'single-page' | 'page-block';
  hideTypes?: boolean;
}

const ProjectHeading: FC<Props> = ({ project, variant = 'page-block', hideTypes }) => {
  const title = project.title;
  const city = project.city;
  const serviceTypes = project.serviceTypes;
  const projectHref = `/${AppRoute.PORTFOLIO}/${project.slug}`;

  const renderTitle = (): JSX.Element => {
    if (variant === 'page-block') {
      return (
        <Link className={styles.link} href={projectHref}>
          <p className={styles.title}>{title}</p>
        </Link>
      );
    }
    return <h1>{title}</h1>;
  };

  return (
    <div className={styles.heading}>
      {title && renderTitle()}
      <div className={styles.cityContainer}>
        {city && <p className={styles.city}>{project.city}</p>}
        {!hideTypes && serviceTypes && (
          <>
            {serviceTypes.map((type) => (
              <Link key={type.id} className={styles.serviceType} href={`/${AppRoute.USLUGI}/${type.slug}`}>
                {type.title}
              </Link>
            ))}
          </>
        )}
      </div>
    </div>
  );
};

export default ProjectHeading;
